import React, { useState } from 'react'
import DashboardHeader from '../Common/DashboardHeader'
import EmailInput from '../reusableComponents/EmailInput'
import FilterEmailInput from '../reusableComponents/FilterEmailInput'
import { useSelector } from 'react-redux'
import SelectStatus from '../reusableComponents/SelectStatus'
import Select from 'react-select'
import CustomerInput from '../reusableComponents/CustomerInput'

const KYC = () => {
    const [userData, setUserData] = useState({
        email: '',
    })
    const [select, setSelect] = useState('');
    const [dataVerification, setDataVerification] = useState('');
    const [kycChecks, setKycChecks] = useState({
        byDate: true,
        byGstin: false,
        byCompanyName: false,
        byFileUploadGstin: false,
        byCustomerKyc: false,
        byVendorKyc: false,
        byFileUploadPan: false,
    })

    const [verificationChecks, setVerificationChecksChecks] = useState({
        fullKyc: false,
        gstin: false,
        pan: false,
        companyName: false,
        cin: false,
        director: false,
        gstinTurnover: false,
        gstinScore: false,
        creditBureau: false
    })

    const v2pRMData = useSelector((state) => state.v2pRMData.V2PRMData);

    const handleChange = (selectedOptions, actionMeta) => {
        // Check if e is defined before destructuring
        if (actionMeta.action === 'select-option' && actionMeta.name) {
            const { name } = actionMeta;
            // Handle the selected options
            // console.log('Selected Options for', name, ':', selectedOptions);
        }
    };

    // Sample options, replace it with your actual data
    const dateOptions = [
        { value: 'Pending', label: 'Pending' },
        { value: 'Success', label: 'Success' },
        { value: 'Failed', label: 'Failed' },
        // Add more options as needed
    ];
    const dataVerificationOptions = [
        { value: 'VENDOR', label: 'VENDOR' },
        { value: 'CUSTOMER', label: 'CUSTOMER' },
        // Add more options as needed
    ];

    const handleSelectChange = (e) => {
        setSelect(e.target.value);
    };
    const handleDataVerificationChange = (e) => {
        setDataVerification(e.target.value);
    };

    function getKycCheck(event) {
        // console.log(event.target.name)
        const { name } = event.target;
        switch (event.target.name) {
            case 'byDate':
                return setKycChecks({
                    byDate: true,
                    byGstin: false,
                    byCompanyName: false,
                    byFileUploadGstin: false,
                    byCustomerKyc: false,
                    byVendorKyc: false,
                    byFileUploadPan: false,
                });
            case 'byGstin':
                return setKycChecks({
                    byDate: false,
                    byGstin: true,
                    byCompanyName: false,
                    byFileUploadGstin: false,
                    byCustomerKyc: false,
                    byVendorKyc: false,
                    byFileUploadPan: false,
                });
            case 'byCompanyName':
                return setKycChecks({
                    byDate: false,
                    byGstin: false,
                    byCompanyName: true,
                    byFileUploadGstin: false,
                    byCustomerKyc: false,
                    byVendorKyc: false,
                    byFileUploadPan: false,
                });
            case 'byFileUploadGstin':
                return setKycChecks({
                    byDate: false,
                    byGstin: false,
                    byCompanyName: false,
                    byFileUploadGstin: true,
                    byCustomerKyc: false,
                    byVendorKyc: false,
                    byFileUploadPan: false,
                });
            case 'byCustomerKyc':
                return setKycChecks({
                    byDate: false,
                    byGstin: false,
                    byCompanyName: false,
                    byFileUploadGstin: false,
                    byCustomerKyc: true,
                    byVendorKyc: false,
                    byFileUploadPan: false,
                });
            case 'byVendorKyc':
                return setKycChecks({
                    byDate: false,
                    byGstin: false,
                    byCompanyName: false,
                    byFileUploadGstin: false,
                    byCustomerKyc: false,
                    byVendorKyc: true,
                    byFileUploadPan: false,
                });
            case 'byFileUploadPan':
                return setKycChecks({
                    byDate: false,
                    byGstin: false,
                    byCompanyName: false,
                    byFileUploadGstin: false,
                    byCustomerKyc: false,
                    byVendorKyc: false,
                    byFileUploadPan: true,
                });
            default:
                return setKycChecks({
                    byDate: true,
                    byGstin: false,
                    byCompanyName: false,
                    byFileUploadGstin: false,
                    byCustomerKyc: false,
                    byVendorKyc: false,
                    byFileUploadPan: false,
                });
        }
    }

    // Define relationships between checkboxes
    const checkboxRelationships = {
        fullKyc: ['gstin', 'pan', 'companyName', 'cin', 'director', 'gstinTurnover', 'gstinScore', 'creditBureau'], // Add more relationships as needed
        pan: ['pan', 'gstin'],
        gstin: ['gstin'],
        companyName: ['pan', 'gstin', 'companyName'],
        cin: ['pan', 'gstin', 'companyName', 'cin'],
        director: ['pan', 'gstin', 'companyName', 'cin', 'director'],
        gstinTurnover: ['gstinTurnover'],
        gstinScore: ['gstinScore'],
        creditBureau: ['creditBureau']
        // Add more relationships as needed
    };

    function getVerificationCheck(event) {
        const name = event.target.name;
        setVerificationChecksChecks((prevChecks) => {
            if (name in checkboxRelationships) {
                // Toggle the state for all related checkboxes based on the state of the clicked checkbox
                const newState = { ...prevChecks };

                checkboxRelationships[name].forEach((relatedCheckbox) => {
                    newState[relatedCheckbox] = !prevChecks[name];
                });

                // Toggle the state of the clicked checkbox
                newState[name] = !prevChecks[name];

                return newState;
            } else {
                // Toggle the state of the clicked checkbox only
                return {
                    ...prevChecks,
                    [name]: !prevChecks[name],
                };
            }
        });
    }
    const options = [
        { value: 'option1', label: 'Option 1' },
        { value: 'option2', label: 'Option 2' },
        { value: 'option3', label: 'Option 3' },
        { value: 'option4', label: 'Option 4' },
    ];

    return (
        <body className='mailsentbody'>
            <div >
                <div className="rightElement">
                    <DashboardHeader />
                    <div className="grid mt-6 grid-cols-12 gap-4">
                        <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                        <div className="col-span-12 md:col-span-8 lg:col-span-8 ">
                            <div className="mt-2 p-2">
                                <div className="col-span-12">
                                    <h1 className="text-4xl text-center font-medium ">Know Your Customer
                                    </h1>
                                </div>
                            </div>
                            <div className='bg-white mx-2 shadow-2xl p-6 mt-4 mb-6 rounded-lg'>
                                <h1>KYC Type</h1>
                                <div className="grid grid-cols-12 gap-4 mt-4 mb-7">
                                    <div className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4">
                                        <input
                                            type="radio"
                                            id="radioOption1"
                                            name="byDate"
                                            checked={kycChecks.byDate === true ? 1 : 0}
                                            onChange={getKycCheck}
                                            className="form-radio h-5 w-5 text-indigo-600"
                                        />
                                        <label
                                            htmlFor="radioOption1"
                                            className="ml-2 text-gray-700"
                                        >
                                            By Date
                                        </label>
                                    </div>
                                    <div className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4">
                                        <input
                                            type="radio"
                                            id="radioOption2"
                                            name="byGstin"
                                            checked={kycChecks.byGstin === true ? 1 : 0}
                                            onChange={getKycCheck}
                                            className="form-radio h-5 w-5 text-indigo-600"
                                        />
                                        <label
                                            htmlFor="radioOption2"
                                            className="ml-2 text-gray-700"
                                        >
                                            By GSTIN
                                        </label>
                                    </div>
                                    <div className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4">
                                        <input
                                            type="radio"
                                            id="radioOption3"
                                            name="byCompanyName"
                                            checked={kycChecks.byCompanyName === true ? 1 : 0}
                                            onChange={getKycCheck} className="form-radio h-5 w-5 text-indigo-600"
                                        />
                                        <label
                                            htmlFor="radioOption3"
                                            className="ml-2 text-gray-700"
                                        >
                                            By Customer Name
                                        </label>
                                    </div>
                                    <div className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4">
                                        <input
                                            type="radio"
                                            id="radioOption4"
                                            name="byFileUploadGstin"
                                            checked={kycChecks.byFileUploadGstin === true ? 1 : 0}
                                            onChange={getKycCheck}
                                            className="form-radio h-5 w-5 text-indigo-600"
                                        />
                                        <label
                                            htmlFor="radioOption4"
                                            className="ml-2 text-gray-700"
                                        >
                                            By File Upload(GSTIN)
                                        </label>
                                    </div>
                                    <div className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4">
                                        <input
                                            type="radio"
                                            id="radioOption5"
                                            name="byCustomerKyc"
                                            checked={kycChecks.byCustomerKyc === true ? 1 : 0}
                                            onChange={getKycCheck}
                                            className="form-radio h-5 w-5 text-indigo-600"
                                        />
                                        <label
                                            htmlFor="radioOption5"
                                            className="ml-2 text-gray-700"
                                        >
                                            Customer KYC
                                        </label>
                                    </div>
                                    <div className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4">
                                        <input
                                            type="radio"
                                            id="radioOption6"
                                            name="byVendorKyc"
                                            checked={kycChecks.byVendorKyc === true ? 1 : 0}
                                            onChange={getKycCheck}
                                            className="form-radio h-5 w-5 text-indigo-600"
                                        />
                                        <label
                                            htmlFor="radioOption6"
                                            className="ml-2 text-gray-700"
                                        >
                                            Vendor KYC
                                        </label>
                                    </div>
                                    <div className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4">
                                        <input
                                            type="radio"
                                            id="radioOption7"
                                            name="byFileUploadPan"
                                            checked={kycChecks.byFileUploadPan === true ? 1 : 0}
                                            onChange={getKycCheck}
                                            className="form-radio h-5 w-5 text-indigo-600"
                                        />
                                        <label
                                            htmlFor="radioOption7"
                                            className="ml-2 text-gray-700"
                                        >
                                            By File Upload(PAN)
                                        </label>
                                    </div>
                                </div>
                                {kycChecks.byDate === true && <>
                                    <div className="grid grid-cols-12 gap-4 mt-2">
                                        <div className="col-span-12 md:col-span-6 lg:col-span-4">
                                            <label
                                                htmlFor="radioOption1"
                                                className="text-gray-700 font-bold text-sm"                                            >
                                                Date
                                            </label>
                                            <SelectStatus
                                                inputStyles={{ padding: '12px' }}
                                                value={select}
                                                onChange={handleSelectChange}
                                                options={dateOptions}
                                            />
                                        </div>
                                        <div className="col-span-12 md:col-span-6 lg:col-span-4">
                                            <label
                                                htmlFor="radioOption1"
                                                className="text-gray-700 font-bold text-sm"                                            >
                                                Data Verification
                                            </label>
                                            <SelectStatus
                                                inputStyles={{ padding: '12px' }}
                                                value={select}
                                                onChange={handleSelectChange}
                                                options={dataVerificationOptions}
                                            />
                                        </div>
                                    </div>
                                </>}
                                {kycChecks.byGstin === true && <>
                                    <div>
                                        <label className="text-gray-700 font-bold text-sm">Enter GSTIN Numbers (Type GSTIN & Press Enter)</label>
                                        <Select
                                            className='mt-2'
                                            isMulti
                                            options={options}
                                            onChange={handleChange}
                                            placeholder="Select Options"
                                        />
                                    </div>
                                </>}
                                {kycChecks.byCompanyName === true && <>
                                    <div>
                                        <h1 className='font-bold'>Enter Company Name (Type Company Name & Press Enter)</h1>
                                        <Select
                                            className='mt-2'
                                            isMulti
                                            options={options}
                                            onChange={handleChange}
                                            placeholder="Select Options"
                                        />
                                    </div>
                                </>}
                                {kycChecks.byFileUploadGstin === true && <>
                                    <div>
                                        <label className="text-gray-700 font-bold text-sm">Upload File (CSV, XLSX, XLS)</label>
                                        <br />
                                        <input type="file" className="mt-2" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                                        <div className='mt-4'>
                                            <a href='https://elslogsuat.azurewebsites.net/template/sample-comparison-template.xlsx' target='_blank' className='text-red-400 font-normal hover:underline'>click here to download template</a>
                                        </div>
                                    </div>
                                </>}
                                {kycChecks.byCustomerKyc === true && <>
                                    <div className="grid grid-cols-12 gap-4 mt-2">
                                        <div className='col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4'>
                                            <label className="text-gray-700 font-bold text-sm">Customer</label>
                                            <CustomerInput
                                                inputStyles={{ padding: '12px' }}
                                            />
                                        </div>
                                    </div>
                                </>}
                                {kycChecks.byVendorKyc === true && <>
                                    <div className="grid grid-cols-12 gap-4 mt-2">
                                        <div className='col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4'>
                                            <label className="text-gray-700 font-bold text-sm">Customer</label>
                                            <CustomerInput
                                                inputStyles={{ padding: '12px' }}
                                            />
                                        </div>
                                        <div className='col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4'>
                                            <label className="text-gray-700 font-bold text-sm">Vendor</label>
                                            <CustomerInput
                                                inputStyles={{ padding: '12px' }}
                                            />
                                        </div>
                                    </div>
                                </>}
                                {kycChecks.byFileUploadPan === true && <>
                                    <div>
                                        <label className="text-gray-700 font-bold text-sm">Upload File (CSV, XLSX, XLS)</label>
                                        <br />
                                        <input type="file" className="mt-2" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                                        <div className='mt-4'>
                                            <a href='https://elslogsuat.azurewebsites.net/template/sample-comparison-template.xlsx' target='_blank' className='text-red-400 font-normal hover:underline'>click here to download template</a>
                                        </div>
                                    </div>
                                </>}
                                {/* Verification Checks Section Starts Here */}
                                <div className='mt-6'>
                                    <div className='border bg-gray-200 py-3 px-3 flex justify-between'>
                                        <h2 className='font-medium text-gray-600'>Verification/Checks</h2>
                                        <div className="flex items-center">
                                            <input
                                                type="checkbox"
                                                id="checkboxOption1"
                                                name="fullKyc"
                                                checked={verificationChecks.fullKyc === true ? 1 : 0}
                                                onChange={getVerificationCheck}
                                                className="form-checkbox h-5 w-5 text-indigo-600 border-2 border-gray-400 bg-gray-200"
                                            />
                                            <label
                                                htmlFor="checkboxOption1"
                                                className="ml-2 text-gray-700 text-sm"
                                            >
                                                Full KYC
                                            </label>
                                        </div>
                                    </div>
                                    <div className='border p-4'>
                                        <div className="grid grid-cols-12 gap-4 mt-2">
                                            {kycChecks.byCompanyName === false && <>
                                                <div className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4">
                                                    <input
                                                        type="checkbox"
                                                        id="checkboxOption2"
                                                        name="gstin"
                                                        checked={verificationChecks.gstin === true ? 1 : 0}
                                                        onChange={getVerificationCheck}
                                                        className="form-checkbox h-5 w-5 text-indigo-600 border-2 border-gray-400 "
                                                    />
                                                    <label
                                                        htmlFor="checkboxOption2"
                                                        className="ml-2 text-gray-700"
                                                    >
                                                        GSTIN Verification
                                                    </label>
                                                </div>
                                            </>}
                                            {kycChecks.byCompanyName === false && <>
                                                <div className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4">
                                                    <input
                                                        type="checkbox"
                                                        id="checkboxOption3"
                                                        name="pan"
                                                        checked={verificationChecks.pan === true ? 1 : 0}
                                                        onChange={getVerificationCheck}
                                                        className="form-checkbox h-5 w-5 text-indigo-600 border-2 border-gray-400 "
                                                    />
                                                    <label
                                                        htmlFor="checkboxOption3"
                                                        className="ml-2 text-gray-700"
                                                    >
                                                        PAN Verification
                                                    </label>
                                                </div>
                                            </>}
                                            <div className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4">
                                                <input
                                                    type="checkbox"
                                                    id="checkboxOption4"
                                                    name="companyName"
                                                    checked={verificationChecks.companyName === true ? 1 : 0}
                                                    onChange={getVerificationCheck}
                                                    className="form-checkbox h-5 w-5 text-indigo-600 border-2 border-gray-400 "
                                                />
                                                <label
                                                    htmlFor="checkboxOption4"
                                                    className="ml-2 text-gray-700"
                                                >
                                                    Company Name Verification
                                                </label>
                                            </div>
                                            <div className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4">
                                                <input
                                                    type="checkbox"
                                                    id="checkboxOption5"
                                                    name="cin"
                                                    checked={verificationChecks.cin === true ? 1 : 0}
                                                    onChange={getVerificationCheck}
                                                    className="form-checkbox h-5 w-5 text-indigo-600 border-2 border-gray-400 "
                                                />
                                                <label
                                                    htmlFor="checkboxOption5"
                                                    className="ml-2 text-gray-700"
                                                >
                                                    CIN Verification
                                                </label>
                                            </div>
                                            <div className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4">
                                                <input
                                                    type="checkbox"
                                                    id="checkboxOption6"
                                                    name="director"
                                                    checked={verificationChecks.director === true ? 1 : 0}
                                                    onChange={getVerificationCheck}
                                                    className="form-checkbox h-5 w-5 text-indigo-600 border-2 border-gray-400 "
                                                />
                                                <label
                                                    htmlFor="checkboxOption6"
                                                    className="ml-2 text-gray-700"
                                                >
                                                    Director Verification
                                                </label>
                                            </div>
                                            {kycChecks.byCompanyName === false && <>
                                                <div className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4">
                                                    <input
                                                        type="checkbox"
                                                        id="checkboxOption7"
                                                        name="gstinTurnover"
                                                        checked={verificationChecks.gstinTurnover === true ? 1 : 0}
                                                        onChange={getVerificationCheck}
                                                        className="form-checkbox h-5 w-5 text-indigo-600 border-2 border-gray-400 "
                                                    />
                                                    <label
                                                        htmlFor="checkboxOption7"
                                                        className="ml-2 text-gray-700"
                                                    >
                                                        GSTIN Turnover Check
                                                    </label>
                                                </div>
                                            </>}
                                            {kycChecks.byCompanyName === false && <>
                                                <div className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4">
                                                    <input
                                                        type="checkbox"
                                                        id="checkboxOption8"
                                                        name="gstinScore"
                                                        checked={verificationChecks.gstinScore === true ? 1 : 0}
                                                        onChange={getVerificationCheck}
                                                        className="form-checkbox h-5 w-5 text-indigo-600 border-2 border-gray-400 "
                                                    />
                                                    <label
                                                        htmlFor="checkboxOption8"
                                                        className="ml-2 text-gray-700"
                                                    >
                                                        GSTIN Score Check
                                                    </label>
                                                </div>
                                            </>}
                                            {kycChecks.byCompanyName === false && <>
                                                <div className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4">
                                                    <input
                                                        type="checkbox"
                                                        id="checkboxOption9"
                                                        name="creditBureau"
                                                        checked={verificationChecks.creditBureau === true ? 1 : 0}
                                                        onChange={getVerificationCheck}
                                                        className="form-checkbox h-5 w-5 text-indigo-600 border-2 border-gray-400 "
                                                    />
                                                    <label
                                                        htmlFor="checkboxOption9"
                                                        className="ml-2 text-gray-700"
                                                    >
                                                        Credit Bureau Check
                                                    </label>
                                                </div>
                                            </>}
                                        </div>
                                    </div>
                                </div>
                                {/* Verification Checks Section Ends Here */}
                                {/* Report Type Section Starts Here  */}
                                <div className='mt-8'>
                                    <h1 className='font-medium text-base text-gray-600'>Report Type</h1>
                                    <div className="grid grid-cols-12 gap-4 mt-2">
                                        <div className="col-span-12 md:col-span-6 lg:col-span-3">
                                            <div className="flex items-center">
                                                <input
                                                    type="radio"
                                                    id="checkboxOption1"
                                                    name="summary"
                                                    checked={true}
                                                    className="form-radio h-5 w-5 text-indigo-600 border-2 "
                                                />
                                                <label
                                                    htmlFor="checkboxOption1"
                                                    className="ml-2 text-gray-700"
                                                >
                                                    Summary Report
                                                </label>

                                            </div>
                                        </div>
                                        <div className="col-span-12 md:col-span-6 lg:col-span-3">
                                            <div className="flex items-center">
                                                <input
                                                    type="radio"
                                                    id="checkboxOption2"
                                                    name="checkboxOptions"
                                                    className="form-radio h-5 w-5 text-indigo-600 border-2 "
                                                />
                                                <label
                                                    htmlFor="checkboxOption2"
                                                    className="ml-2 text-gray-700"
                                                >
                                                    Detailed Report
                                                </label>

                                            </div>
                                        </div>
                                        <div className="col-span-12 md:col-span-6 lg:col-span-3">
                                            <div className="flex items-center">
                                                <input
                                                    type="radio"
                                                    id="checkboxOption3"
                                                    name="checkboxOptions"
                                                    className="form-radio h-5 w-5 text-indigo-600 border-2 "
                                                />
                                                <label
                                                    htmlFor="checkboxOption3"
                                                    className="ml-2 text-gray-700"
                                                >
                                                    Both
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Report Type Section Ends Here */}
                                {/* Report Delivery Section Starts Here*/}
                                <div className='mt-8'>
                                    <h1 className='font-medium text-base text-gray-600'>Report Delivery</h1>
                                    <div className="grid grid-cols-12 gap-4 mt-2">
                                        <div className="col-span-12 md:col-span-6 lg:col-span-3">
                                            <div className="flex items-center">
                                                <input
                                                    type="radio"
                                                    id="checkboxOption4"
                                                    name="download"
                                                    checked={true}
                                                    className="form-radio h-5 w-5 text-indigo-600 border-2 "
                                                />
                                                <label
                                                    htmlFor="checkboxOption4"
                                                    className="ml-2 text-gray-700"
                                                >
                                                    Download Report
                                                </label>

                                            </div>
                                        </div>
                                        <div className="col-span-12 md:col-span-6 lg:col-span-3">
                                            <div className="flex items-center">
                                                <input
                                                    type="radio"
                                                    id="checkboxOption1"
                                                    name="checkboxOptions"
                                                    className="form-radio h-5 w-5 text-indigo-600 border-2 "
                                                />
                                                <label
                                                    htmlFor="checkboxOption1"
                                                    className="ml-2 text-gray-700"
                                                >
                                                    Email Report
                                                </label>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Report Delivery Section Ends Here */}
                                <div className='mt-8'>
                                    <h1 className='text-black font-bold text-base'>Report will be available to download within 20-30 minutes after process started. or you can setup the "email report" option to receive it on email.</h1>
                                </div>
                                <div className=' border-t mt-5 mb-5' />
                                <div className='text-center'>
                                    <button className='vtpRm-action-button'>Start KYC Process</button>
                                </div>
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                    </div>
                </div>
            </div >
        </body >
    )
}

export default KYC
